import { useNavigate } from "react-router";
import { useClientPortalConfigContext } from "../context";
import { useCallback } from "react";

export interface IClientPortalRouterHook {
    (path: string): void;
}

export function useClientPortalNavigate(): IClientPortalRouterHook {
    const navigate = useNavigate();
    const { clientPortalGuid } = useClientPortalConfigContext();

    return useCallback(
        (path: string) => void navigate(`/clientportal/${clientPortalGuid}/${path}`),
        [navigate, clientPortalGuid]
    );
}
